import { RMApiRequestEnum } from "@/constants";
import { UserSettings } from "@/types/userSettings";
import { baseQuery, RestApiService, onQueryStarted } from "@develos/next-library";
import { createApi } from "@reduxjs/toolkit/query/react";
import { deserializePortalSettings } from "./deserialize";
import { setParametersExceededFilterMode, setWeightLimitFilterMode } from "./slice";

export const portalSettingsApi = createApi({
    baseQuery: baseQuery(RestApiService.ProjectApi),
    reducerPath: 'portalSettingsApi',
    endpoints: build => ({
        getUserSettings: build.query<UserSettings, void>({
            query: () => ({
                url: 'UserSettings/GetUserSettings',
                method: "GET"
            }), 
            onQueryStarted: onQueryStarted(RMApiRequestEnum.getUserSettings, (dispatch, result) => {
                if (result?.settings) {
                    const portalSettings = deserializePortalSettings(result.settings)
                    dispatch(setParametersExceededFilterMode(portalSettings.parametersExceededFilterMode))
                    dispatch(setWeightLimitFilterMode(portalSettings.weightLimitFilterMode))
                }
            })
        }),
        updateUserSettings : build.mutation<void, UserSettings>({
            query: (userSettings) => ({
                url: 'UserSettings/UpdateUserSettings',
                method: "PUT",
                body: userSettings
            }), 
            onQueryStarted: async (userSettings, { dispatch, queryFulfilled }) => {
                    if (userSettings?.settings) {
                    const portalSettings = deserializePortalSettings(userSettings.settings);
                    dispatch(setParametersExceededFilterMode(portalSettings.parametersExceededFilterMode));
                    dispatch(setWeightLimitFilterMode(portalSettings.weightLimitFilterMode));
                }
                await queryFulfilled;
            },
        })
    })
});

export const {
    useGetUserSettingsQuery,
    useUpdateUserSettingsMutation
} = portalSettingsApi;

export const {
    useQuerySubscription: useGetPortalSettingsSubscritpion
} = portalSettingsApi.endpoints.getUserSettings
